const Mn = require('backbone.marionette');
const Template = require('view');
const tplProduto = require('./resultado.twig');
const tplKit = require('./resultado-kit.twig');
const $ = require('jquery');

const View = Mn.View.extend({
	tagName: 'li',
	className: function() {
		if (this.model.get('controller') == 'produto') {
			return 'each-home-product trigger-quantidade box-produto';
		} 
		return '';
	},	
	initialize: function() {
		if (this.model.get('controller') == 'produto') {
			this.template = tplProduto;
		} else {
			this.template = tplKit;		
		}
	},
	onRender: function() {
		window.setTimeout(function() {
			console.log('busca/resultado.js:onRender');
			jQuery('[name=porcao_id]').trigger('change');
		});
	}
});

View.setRenderer(function(template, data) {
	return Template.renderString(template, data);
});

module.exports = View;


//////////////////
// WEBPACK FOOTER
// ./views/busca/resultado.js
// module id = 54
// module chunks = 0